import { useTranslation } from 'react-i18next';

import i18n from '~/shared/lib/i18n';

import en from './locales/en.json';
import ru from './locales/ru.json';

const scopeName = 'ErrorPage';

i18n.addResourceBundle('ru', scopeName, ru);
i18n.addResourceBundle('en', scopeName, en);

export const useLocalization = () => {
  return useTranslation(scopeName);
};
